///-------------------------------------------
///|                                         |
///|     Generated code, do not edit.        |
///|                                         |
///-------------------------------------------
  

import {
  VenueApiKeyFlag,
  FixSessionType,
} from "./types";

import {
  IParties,
} from "./position_management";


///Description: Api key capability
export enum ApiKeyCapability {
 portfolio_management,
 order_entry,
 market_data,
 quoting,
 quoting_order_entry,
 refdata,
}

///Description: Api key capability
export enum K8Namespace {
 public_api,
 refdata_fetcher,
 mktdata_feed_handler,
}

export interface IVenueApiKey {
 key_id: string;
 account_id: string | null;
 portfolio_id: string | null;
 access_key: string | null;
 secret_key: string;
 passphrase: string | null;
 mktdata_api_key: string | null;
 venue: string;
 connection: string | null;
 sender_comp_id: string | null;
 target_comp_id: string | null;
 availability_zone: string | null;
 allow_ip: string | null;
 quoting_allow_ip: string | null;
 venue_api_key_flags: VenueApiKeyFlag[] | null;
 fix_version: string | null;
 fix_session_type: FixSessionType | null;
 api_capabilities: ApiKeyCapability[] | null;
 namespaces: K8Namespace[] | null;
 persist_session: boolean | null;
 passthrough_parties: boolean | null;
 passthrough_account_id: boolean | null;
 default_parties: IParties[] | null;
}

export interface IVenueApiKeyResource {
 key_id: string;
 account_id: string | null;
 portfolio_id: string | null;
 access_key: string | null;
 venue: string;
 api_capabilities: ApiKeyCapability[] | null;
}

export interface IListVenueApiKeyResource {
 keys: IVenueApiKeyResource[];
}

